import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    paymentModalContainer: {
        boxShadow: "none",
        borderRadius: "24px",
    },
    paper: {
        minWidth: "400px",
    },
    wrapper: {
        margin: "1px",
        position: "relative",
    },
    buttonProgress: {
        color: "#053742",
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    stepContainer: {
        width: "50% !important",
        margin: "0 auto !important",
        textTransform: "capitalize",
        fontFamily: "'Work Sans', sans-serif",
        fontSize: " 18px !important",
        lineHeight: "18px !important",
    },
});

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
}
export default function DialogTermsAndConditions(props: any) {
    const classes = useStyles();
    const fullScreen = useMediaQuery("(max-width:600px)");
    const [value, setValue] = React.useState(props?.default ? 0 : 1);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (props.openState) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [props.openState]);

    return (
        <div id="payment-modal" className={classes.paymentModalContainer}>
            <Dialog
                fullScreen={fullScreen}
                classes={{ paper: classes.paper }}
                open={props.openState}
                onClose={props.handleClose}
                fullWidth={true}
                disableEnforceFocus
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                style={{
                    // borderRadius: "24px",
                    background: "none",
                }}
                PaperProps={{
                    style: {
                        pointerEvents: "auto",
                        height: !fullScreen ? "700px" : "100%"
                        // borderRadius: "24px"
                    },
                }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
                        <Tab label="Legalese" {...a11yProps(0)} />
                        <Tab label="Additional Fees" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <TabPanel value={value} index={0}>
                            <Grid>
                                <Typography variant="body2" gutterBottom id="terms-and-condition">
                                    By submitting a transaction you are consenting to have the full amount of the transaction debited from your account and state that you are the cardholder and/or have express consent from the cardholder or account owner authorizing you to process this transaction. If an ACH return or chargeback results from this transaction, Inosio will charge a fee to the payer and may block all, or some segment of, the Inosio platform from being used by the payer. If only the convenience fee is challenged, Inosio will return the full amount of the transaction to the Payer (not only the convenience fee). This will have consequences with the payer's Property Manager and may result in eviction or other legal proceeding and derogatory remarks on the payer's renter profile. Inosio and its Property Manager customers will pursue and prosecute all fraudulent transactions to the fullest extent allowed by law.
                                </Typography>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Grid item pb={4}>
                                <Typography variant="body2" gutterBottom id="terms-and-condition">
                                    If an ACH return or chargeback results from this transaction, Inosio will charge a fee to the payer and may block all, or some segment of, the Inosio platform from being used by the payer in the future.
                                </Typography>
                            </Grid>
                            <Grid item sx={{ color: '#F1F0F5' }}>
                                <Divider style={{ background: '#F1F0F5', }} />
                                <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Grid item p={1}>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition">
                                            NACHA return
                                        </Typography>
                                    </Grid>
                                    <Grid item p={1}>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition">
                                            per $15
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider style={{ background: '#F1F0F5' }} />
                                <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Grid item p={1}>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition">
                                            Non-Fraudulent Chargeback
                                        </Typography>
                                    </Grid>
                                    <Grid item p={1}>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition">
                                            per $15
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider style={{ background: '#F1F0F5' }} />
                            </Grid>
                            <Grid item pt={4}>
                                <Typography variant="body2" gutterBottom id="terms-and-condition">
                                    Inosio and its Property Manager customers will pursue and prosecute all fraudulent transactions to the fullest extent allowed by law.
                                </Typography>
                            </Grid>
                        </TabPanel>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'flex-start', padding: 2, }}>
                    <Button
                        onClick={props.handleClose}
                        sx={{ borderRadius: '20px', fontSize: 'small' }} size="large">
                        Back
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
